// color set used for multiple avatar initialisations
let AI_COLOR_PATTERNS = ['#7E3B80', '#4F4473', '#31ACD3', '#A9D44C', '#39B665', '#00A57F', '#E63D61', '#B81A40', '#F39EAB', '#D2CBC4'];
const MAX_LETTERS = 2;

class AvatarInitials {
    constructor({el, avatarIdx, nameAndColorMap, maxLetters = MAX_LETTERS, rebrand2020, disableWidth}) {
        this.$root = el;

        if (rebrand2020) {
            AI_COLOR_PATTERNS = ['#FF91F0', '#EB73DE', '#33E5DB', '#0AB8AD', '#39B665', '#0F6378', '#FF7370', '#D4524F', '#FFF4F4', '#E0DED9'];
        }

        this.maxLetters = maxLetters;
        this.completeName = this.$root.attr('data-completeName');
        this.disableWidth = disableWidth; // In case we want to disable module width attribution
        this.width = this.$root.attr('width');
        this.initials = this.getAvatarInitials(this.completeName);
        this.color = this.getAvatarColor(nameAndColorMap, this.completeName, avatarIdx);

        this.setUpAvatar(this.$root);
    }

    getAvatarInitials(completeName) {
        function getFirstLetter(string) {
            const cleanedString = string.replace(/[';,:()]/g, '');
            return cleanedString.charAt(0);
        }

        let arrayName = completeName.split(' ');
        arrayName = arrayName.slice(0, this.maxLetters);
        arrayName.forEach((str, idx) => {
            arrayName[idx] = getFirstLetter(str);
        });

        return arrayName.join('').toUpperCase();
    }

    getAvatarColor(nameAndColorMap, completeName, avatarIdx) {
        const avatarWithSameName = nameAndColorMap.filter((el) => el.name === completeName)[0];

        if (avatarWithSameName !== undefined) {
            return avatarWithSameName.color;
        } else {
            nameAndColorMap.push({name: completeName, color: AI_COLOR_PATTERNS[avatarIdx]});
            return AI_COLOR_PATTERNS[avatarIdx];
        }
    }

    setUpAvatar(el) {
        const id = this.$root.attr('id') ? `id=${this.$root.attr('id')}` : '';
        const AVATAR = `
            <div class="avatar-initials ${this.$root.attr('class')}" ${id} style="
                background-color: ${this.color};
                ${this.setAvatarWidth()}  
            ">${this.initials}</div>`;

        el.after(AVATAR);
        el.remove();
    }

    setAvatarWidth() {
        if (this.disableWidth) {
            return '';
        }
        return `width: ${this.width}px; height: ${this.width}px;`;
    }
}

Hop.avatar = {};

Hop.avatar.replace = function ($container, opts = {}) {
    const avatars = $container.find('[data-nopp]');
    const NAME_AND_COLOR_MAP = [];

    avatars.each((idx, el) => {
        new AvatarInitials({
            el: $(el),
            avatarIdx: idx,
            nameAndColorMap: NAME_AND_COLOR_MAP,
            maxLetters: opts.maxLetters,
            rebrand2020: opts.rebrand2020 || false,
            disableWidth: opts.disableWidth,
        });
    });
};

Hop.defineModule('avatar-initials', (root, param) => {
    Hop.avatar.replace($(root), param);
});
